import React from "react";
import { motion } from "framer-motion";

const rowVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, ease: "easeOut", duration: 0.5 },
  }),
  hover: { scale: 1.02 },
};

export default function CreativeApproachSection() {
  return (
    <section className="bg-[#FFE600] text-[#EF4293] w-full rounded-xl md:rounded-2xl overflow-hidden relative">
      <div className="flex flex-col md:flex-row">
        {/* Main Content */}
        <div className="flex-1 flex flex-col divide-y divide-[#EF4293]/40 px-4 md:px-6 lg:px-10 py-6 space-y-6">
          {/* Row 1 */}
          <motion.div
            className="flex items-center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0}
            variants={rowVariants}
            whileHover="hover"
          >
            <div className=" flex items-center justify-center pr-4 w-12">
              <div className="rotate-[-90deg] origin-center text-black text-sm font-bold tracking-tight whitespace-nowrap">
                HUM KAUN?
              </div>
            </div>
            <div className="flex-1 text-2xl md:text-7xl  font-medium leading-tight relative text-right md:text-left">
              WE <br className="md:hidden" /> <span className="font-bold">DESIGN</span> AND{" "}
              <span className="font-bold">LAUNCH</span> <span className="hidden md:inline">THE</span> 
              <br />
               <span className="block text-right  md:mr-12"> <span className="inline md:hidden">THE</span> CREATIVELY DIFFERENT</span> 
              <span className="block md:absolute right-0 bottom-0 text-black text-base align-middle">
                by:
              </span>
            </div>
          </motion.div>

          {/* Row 2 */}
          <motion.div
            className="flex items-center pt-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={1}
            variants={rowVariants}
            whileHover="hover"
          >
            <div className="flex items-center justify-center pr-4 w-12">
              <div className="rotate-[-90deg] origin-center text-black text-sm font-bold tracking-tight whitespace-nowrap">
                APPROACH
              </div>
            </div>
            <div className="flex-1 text-2xl md:text-7xl font-medium leading-tight relative text-right md:text-left">
              LEVERAGING <br className="md:hidden" /> EVERY BIT OF
              <br />
              <span className="font-bold">DATA</span>
              <span className="block md:absolute right-0 bottom-0 text-black text-base align-middle">
                to:
              </span>
            </div>
          </motion.div>

          {/* Row 3 */}
          <motion.div
            className="flex items-center pt-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={2}
            variants={rowVariants}
            whileHover="hover"
          >
            <div className="flex items-center justify-center pr-4 w-12">
              <div className="rotate-[-90deg] origin-center text-black text-sm font-bold tracking-tight whitespace-nowrap">
                GOAL
              </div>
            </div>
            <div className="w-full text-2xl text-2xl md:text-7xl font-medium leading-tight text-right md:mr-12">
              EXECUTE UNCONVENTION–
              <br />
              AL SOLUTIONS
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
